<template>
  <div>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs6>
            <v-layout align-center justify-start row fill-height>
              <div>
                <h2>Series</h2>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <!-- Action buttons -->
            <v-layout align-center justify-end row fill-height>
              <div>
                <v-btn color="primary" @click="openNewSerieForm()">
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('CREAR SERIE') }}
                </v-btn>
              </div>
            </v-layout>
            <!-- End action buttons -->
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <open-billing-serie-table
          ref="serieTable"
          :selectedType="selectedType"
          @on-edit-serie="onEditSerie($event)"
          @on-delete-serie="onDeleteSerie($event)"
          @on-change-type="onChangeSelectedType($event)"
        ></open-billing-serie-table>
      </v-card-text>
    </v-card>
    <open-billing-serie-form
      :show-modal="showSerieModalForm"
      :key="serieFormKey"
      :serie-id="selectedSerieId"
      :selected-type="selectedType"
      @click-on-close="closeSerieModalForm()"
      @on-saved-serie="onSavedSerie($event)"
    ></open-billing-serie-form>
    <!-- Modal to delete series -->
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteSerieModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de eliminar la serie seleccionada?
                  </h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeDeleteSerieModal()">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmDeleteSerie()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
  </div>
</template>

<script>
import OpenBillingSerieTable from '@/modules/openbilling/components/OpenBillingSerieTable';
import OpenBillingSerieForm from '@/modules/openbilling/components/OpenBillingSerieForm';
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'OpenBillingSeries',
  components: {
    'open-billing-serie-table': OpenBillingSerieTable,
    'open-billing-serie-form': OpenBillingSerieForm,
  },
  props: [],
  data() {
    return {
      showSerieModalForm: false,
      showDeleteSerieModal: false,
      serieFormKey: 0,
      selectedSerieId: null,
      selectedType: 'factura',
    };
  },
  mounted() {},
  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  methods: {
    openNewSerieForm() {
      this.showSerieModalForm = true;
    },
    closeSerieModalForm() {
      this.showSerieModalForm = false;
      this.resetSerieForm();
    },
    resetSerieForm() {
      this.serieFormKey++;
      this.selectedSerieId = null;
    },
    onSavedSerie() {
      this.closeSerieModalForm();
      this.getSeries();
    },
    onEditSerie(serie) {
      this.selectedSerieId = serie.id;
      this.showSerieModalForm = true;
    },
    onDeleteSerie(serie) {
      this.selectedSerieId = serie.id;
      this.showDeleteSerieModal = true;
    },
    confirmDeleteSerie() {
      this.deleteSingleSerie(this.selectedSerieId);
    },
    closeDeleteSerieModal() {
      this.showDeleteSerieModal = false;
      this.selectedSerieId = null;
    },
    deleteSingleSerie(id) {
      apiCtrl
        .post(`/openbilling/${this.clavedat}/series/delete`, { id: id })
        .then(() => {
          this.closeDeleteSerieModal();
          this.getSeries();
        })
        .catch(err => {
          console.log(err);
          this.closeDeleteSerieModal();
        });
    },
    getSeries() {
      this.$refs.serieTable.getBillingSeries();
    },
    onChangeSelectedType(type) {
      this.selectedType = type;
      this.closeSerieModalForm();
    },
  },
  watch: {},
};
</script>

<style scoped></style>
